import React from 'react';
import './StartChat.scss';
import { IconStartChat } from '../../../../../../../assets/images';

function StartChat(props) {
    return (
        <div className='start_chat'>
            <div className='start_chat_inner'>
                <div className='start_chat_icon'>
                    <IconStartChat />
                </div>
                <div className='start_chat_desc'>
                    <strong>Start New Conversation!</strong>
                    <p>Privately talk with the host and other participants.
                    </p>
                </div>
            </div>
        </div>
    );
}

export default StartChat;